// API service to handle requests without CORS issues
class ApiService {
  constructor() {
    this.baseUrl = 'https://xiadot.com/vendor_api';
    this.simulationMode = true; // Re-enable until PHP files are properly uploaded
  }

  async request(endpoint, options = {}) {
    // If simulation mode is enabled, simulate API responses
    if (this.simulationMode) {
      return this.simulateResponse(endpoint, options);
    }

    const url = `${this.baseUrl}${endpoint}`;
    
    try {
      console.log(`Making API request to: ${url}`);
      
      const response = await fetch(url, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
      });

      console.log(`API response status: ${response.status}`);

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned HTML instead of JSON. Check server configuration.');
      }

      const data = await response.json();
      console.log('API response data:', data);
      return data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  simulateResponse(endpoint, options) {
    console.log(`🔧 SIMULATION MODE: Simulating ${endpoint}`);
    
    // Simulate forgot password
    if (endpoint.includes('forgot_password.php')) {
      const body = JSON.parse(options.body);
      const email = body.email;
      
      console.log(`📧 Simulating forgot password for: ${email}`);
      
      // Generate a fake reset token
      const fakeToken = 'fake_token_' + Math.random().toString(36).substr(2, 9);
      const resetLink = `http://localhost:3000/yuroshopy/vendor/reset-password?token=${fakeToken}`;
      
      return {
        success: true,
        message: "Password reset instructions have been sent to your email address.",
        debug_link: resetLink,
        email: email
      };
    }
    
    // Simulate token validation
    if (endpoint.includes('validate_reset_token.php')) {
      const token = endpoint.split('token=')[1];
      
      if (token && token.startsWith('fake_token_')) {
        return {
          success: true,
          message: "Token is valid",
          valid: true,
          email: "vendor@example.com"
        };
      } else {
        return {
          success: false,
          message: "Invalid or expired reset link",
          valid: false
        };
      }
    }
    
    // Simulate password reset
    if (endpoint.includes('reset_password.php')) {
      const body = JSON.parse(options.body);
      const token = body.token;
      
      if (token && token.startsWith('fake_token_')) {
        return {
          success: true,
          message: "Password has been reset successfully. You can now login with your new password."
        };
      } else {
        return {
          success: false,
          message: "Invalid or expired reset token"
        };
      }
    }
    
    return {
      success: false,
      message: "Unknown endpoint"
    };
  }

  async forgotPassword(email) {
    return this.request('/vendor/auth/forgot_password.php', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

  async validateResetToken(token) {
    return this.request(`/vendor/auth/validate_reset_token.php?token=${token}`, {
      method: 'GET',
    });
  }

  async resetPassword(token, password) {
    return this.request('/vendor/auth/reset_password.php', {
      method: 'POST',
      body: JSON.stringify({ token, password }),
    });
  }
}

export const apiService = new ApiService();
